import React, { useContext, useEffect, useState, useMemo, useCallback } from "react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import axiosInstance from "./axiosInstance";
import { A11y, Autoplay, Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import CardGroub from "../../components/cardGroup/CardGroub";
import { Link } from "react-router-dom";
import { AuthContext } from "../../AuthContext";
import ImageComponent from "./ImageComponent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDoubleLeft, faAngleDoubleRight } from "@fortawesome/free-solid-svg-icons";

const Articles = () => {
  const [articlesCategory, setArticlesCategory] = useState([]);
  const [allArticles, setAllArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const { setArticleDet } = useContext(AuthContext);

  useEffect(() => {
    const fetchArticleCat = async () => {
      setLoading(true)
      try {
        const response = await axiosInstance.get("https://sychoclinicapi.runasp.net/api/Categories/Details");
        setArticlesCategory(response.data);
      } catch (error) {
      }
    };

    fetchArticleCat();
  }, []);

  // Fetch all articles
  useEffect(() => {
    const fetchAllArticles = async () => {
      try {
        setLoading(true)
        const response = await axiosInstance.get("https://sychoclinicapi.runasp.net/api/Categories");
        setAllArticles(response.data);
      } catch (error) {
      } finally {
      }
    };

    fetchAllArticles();
  }, []);

  // Memoize the organized articles to avoid re-computation
  const organizedArticles = useMemo(() => {
    setLoading(true)
    if (articlesCategory.length > 0 && allArticles.length > 0) {
      const organizedArray = articlesCategory.map((item) => {
        if (!item.categoriesArticleId) {
          console.warn(`categoriesArticleId is undefined for article id: ${item.id}`);
          return item;
        }

        const correspondingItem = allArticles.find(
          (obj) => obj.id === item.categoriesArticleId
        );

        if (!correspondingItem) {
          console.warn(`No corresponding item found for article id: ${item.categoriesArticleId}`);
          return item;
        }

        return {
          ...item,
          correspondingItem: {
            description: correspondingItem.description,
            categoryName: correspondingItem.typeName,
            image: correspondingItem.image,
          },
        };
      });
  setLoading(false)
      const categories = allArticles.reduce((uniqueCategories, item) => {
        if (item.typeName && !uniqueCategories.includes(item.typeName)) {
          uniqueCategories.push(item.typeName);
        }
        return uniqueCategories;
      }, []);

      return categories.map((category) => {
        const articles = organizedArray.filter(
          (item) => item.correspondingItem && item.correspondingItem.categoryName === category
        );
        return { category, articles };
      });
    }
    return [];
  }, [articlesCategory, allArticles]);

  useEffect(() => {
    setArticleDet(organizedArticles);
  }, [organizedArticles, setArticleDet]);

  const renderSwiperSlides = useCallback((articles) => {
    return articles.map((article) => (
      <SwiperSlide key={article.id}>
        <Link to={`details/${article.id}`}>
          <CardGroub
            description={article.description}
            title={article.categoryName}
          >
            <ImageComponent height={"180px"} base64String={article.image} border={"27px"}/>
          </CardGroub>
        </Link>
      </SwiperSlide>
    ));
  }, []);

  return (
    <div id="articles">
      {loading &&
        <div
          style={{
            backgroundColor: "#EEE",
            width: "100%",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "absolute",
            zIndex: "1000",
            opacity: ".6",
          }}
        >
          <span className="spinner-border text-dark" role="status"></span>
        </div>}
      
      {organizedArticles.map((categoryItem) => (
        categoryItem.articles.length > 0 && (
          <div
            key={categoryItem.category}
            className="d-flex bgHome border-none shadow justify-content-center align-items-center flex-column py-5"
          >
            <h2 className="fw-bold fs-1 pb-2 mb-5 mt-3 text-center m-auto fw-bold after position-relative">
              {categoryItem.category}
            </h2>
            <div style={{ position: "relative", width: "100%" }}>
              <div
                className="swiper-button-next"
                style={{
                  position: "absolute",
                  top: "50%",
                  right: "10px",
                  zIndex: 10,
                  display: "flex",
                  justifyContent: "center",
                  padding: "8px",
                  textAlign: "center",
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  backgroundColor: "#25e",
                  alignItems: "center",
                  color: "#fff",
                  cursor: "pointer",
                }}
              >
                <FontAwesomeIcon icon={faAngleDoubleRight} />
              </div>
              <div
                className="swiper-button-prev"
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "10px",
                  zIndex: 10,
                  display: "flex",
                  justifyContent: "center",
                  padding: "8px",
                  textAlign: "center",
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  backgroundColor: "#25e",
                  alignItems: "center",
                  color: "#fff",
                  cursor: "pointer",
                }}
              >
                <FontAwesomeIcon icon={faAngleDoubleLeft} />
              </div>
              <Swiper
                style={{
                  width: "80%",
                  backgroundColor: "#fff",
                  padding: "5px 30px",
                  borderRadius: "37px",
                }}
                navigation={{
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev",
                }}
                autoplay={{
                  delay: 3000,
                }}
                speed={1000}
                modules={[Autoplay, Navigation, Pagination, A11y]}
                spaceBetween={50}
                breakpoints={{
                  992: {
                    slidesPerView: 3,
                  },
                  779: {
                    slidesPerView: 2,
                  },
                  0: {
                    slidesPerView: 1,
                  },
                }}
                pagination
              >
                {renderSwiperSlides(categoryItem.articles)}
              </Swiper>
            </div>
          </div>
        )
      ))}
    </div>
  );
};

export default Articles;
